<template>
  <div id="chart">
    <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
 import { mapState, mapGetters } from "vuex";
 import axios from 'axios';  
//  import { ROOT_URL } from '@/api/connectingUrls';
 import VueApexCharts from "vue-apexcharts";

export default {
  name: "Chart",
  components: {
    apexchart: VueApexCharts
  },
  // created() {
  //   this.series.forEach(item => {
  //     item.data = item.data.map(d => {
  //       if (d && d.includes(":")) {
  //         return d.replace(":", ".");
  //       } else {
  //         return d;
  //       }
  //     });
  //   });
  // },
  data() {
    return {
      // rootUrl: ROOT_URL,
      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          height: 550,
          stacked: true
        },
        title: {
            text: "Response Tracker",
            style: {
                color: "#008FFB",
            },
        },
        noData: {
            text: "No data available",
        },
        xaxis: {
          type: 'text',
          categories: [],
          title: {
              text: "Project ID",
              style: {
                  color: "#008FFB",
              },
          },
        },
        yaxis: [
          {
            axisTicks: {
                show: true,
            },
            axisBorder: {
                show: true,
                color: "#008FFB",
            },
            title: {
              text: "Number of Response",
              style: {
                  color: "#008FFB",
              },
            },
            
          },
          // {
          //   opposite: true,
          //   axisTicks: {
          //       show: true,
          //   },
          //   axisBorder: {
          //       show: true,
          //       color: "#00E396",
          //   },
          // }
        ],
        dataLabels: {
            enabled: false,
        },
        
      }
    };
  },
    computed: {
      ...mapGetters(["isLoggedIn","indexData"])
    },

    created() {
      // this.initialize();
      this.fetchReport();
    },
    // mounted() {
    //    this.getResponseTracker();
    // },
    
    methods: {
      // async getResponseTracker(){
      //   try {
      //       const token = window.localStorage.getItem('datadash_token');
      //       if(token != null){
      //       //perfectly not call base url   
      //       return await axios.get(`${this.rootUrl}/${'response-tracker'}`,{
      //           headers:{
      //             Authorization: `Bearer ${token}`,
      //             'Content-Type': 'application/json'
      //           }
      //       })
      //       .then(response => {
      //         console.log(response);
      //           if (response.data.statusCode == 200){
      //               this.series = response.data.data.response_tracker.series;
      //               this.chartOptions = {
      //               xaxis: {
      //                 categories: response.data.data.response_tracker.categories,
      //                 type: "text",
      //               },
      //             };
      //           }
      //       })
      //     }}catch (error) {
      //       console.log(error);
      //     }
      // },
      async fetchReport() {
        await this.$store.dispatch("setIndexData", ["response-tracker"]);
        this.updateCharts();
      },
      async updateCharts() {  
        this.series = this.indexData.response_tracker.series;
        this.chartOptions = {
          xaxis: {
            categories: this.indexData.response_tracker.categories,
          },
        };
      }
    }
};
</script>
<style scoped>
  i.v-icon.bg-icon {
    position: absolute;
    opacity: 0.15;
    font-size: 75px !important;
    left: 15px;
    bottom: 15px;
  }

  body {
    background-color: #f1f1f1;
  }

  content {
    background-color: red !important;
  }

  .pa-3 {
    z-index: 0 !important;
  }
</style>